import React, { useEffect, useState } from "react";
import "./NCALayerModal.css";

export default function NCALayerModal({ open, locale = "kz", onClose }) {
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const t = {
    kz: {
      title: "NCALayer іске қосылмаған",
      text: "ЭЦҚ арқылы қол қою үшін NCALayer бағдарламасын іске қосыңыз.",
      hint: "Бағдарлама іске қосылғаннан кейін қайта тексеріңіз",
      error:
        "NCALayer іске қосылмаған немесе қосылым мүмкін болмады. Қайта көріңіз.",
      success: "NCALayer сәтті қосылды",
      download: "NCALayer жүктеу",
      retry: "Мен қостым — тексеру",
      checking: "Тексерілуде...",
      close: "Жабу",
    },
    ru: {
      title: "NCALayer не запущен",
      text: "Чтобы подписать ЭЦП, запустите программу NCALayer.",
      hint: "После запуска программы выполните повторную проверку",
      error:
        "NCALayer не запущен или соединение недоступно. Попробуйте ещё раз.",
      success: "NCALayer успешно подключён",
      download: "Скачать NCALayer",
      retry: "Я запустил — проверить",
      checking: "Проверка...",
      close: "Закрыть",
    },
  }[locale];

  useEffect(() => {
    const handler = (e) => {
      const st = e.detail;

      if (st.status === "connecting") {
        setChecking(true);
        setError(null);
        setSuccess(false);
      }

      if (st.status === "connected") {
        setChecking(false);
        setError(null);
        setSuccess(true);

        // ✨ даём показать success-анимацию
        setTimeout(() => {
          onClose();
          setSuccess(false);
        }, 800);
      }

      if (st.status === "not_running" || st.status === "disconnected") {
        setChecking(false);
        setSuccess(false);
        setError(t.error);
      }

      if (st.status === "error") {
        setChecking(false);
        setSuccess(false);
        setError(st.errorMessage || t.error);
      }
    };

    window.addEventListener("ncalayer-status", handler);
    return () => window.removeEventListener("ncalayer-status", handler);
  }, [locale, onClose, t.error]);

  const handleRetry = () => {
    setChecking(true);
    setError(null);
    setSuccess(false);
    window.NCA.connect();
  };

  if (!open) return null;

  return (
    <div className="nca-backdrop">
      <div className={`nca-modal ${success ? "nca-success-mode" : ""}`}>
        {/* ❌ Error */}
        {error && !success && (
          <div className="nca-alert">
            <span className="nca-alert-icon">⚠️</span>
            <span>{error}</span>
          </div>
        )}

        {/* ✅ SUCCESS */}
        {success ? (
          <div className="nca-success">
            <div className="nca-success-icon">
              <svg viewBox="0 0 52 52">
                <circle cx="26" cy="26" r="25" fill="none" />
                <path fill="none" d="M14 27l7 7 17-17" />
              </svg>
            </div>
            <h3 className="nca-success-text">{t.success}</h3>
          </div>
        ) : (
          <>
            {/* Normal content */}
            <div className="nca-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L4 5v6c0 5 3.5 9.7 8 11 4.5-1.3 8-6 8-11V5l-8-3z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </svg>
            </div>

            <h3 className="nca-title">{t.title}</h3>
            <p className="nca-text">{t.text}</p>
            <p className="nca-hint">{t.hint}</p>

            <div className="nca-actions">
              <a
                href="https://pki.gov.kz/ncalayer/"
                target="_blank"
                rel="noreferrer"
                className="nca-btn nca-btn-outline"
              >
                {t.download}
              </a>

              <button
                onClick={handleRetry}
                className="nca-btn nca-btn-primary"
                disabled={checking}
              >
                {checking && <span className="nca-spinner" />}
                {checking ? t.checking : t.retry}
              </button>

              <button
                onClick={onClose}
                className="nca-btn nca-btn-ghost"
                disabled={checking}
              >
                {t.close}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
